import React from "react";
import { SyncOutlined } from "@ant-design/icons";
import { Button } from "antd";
import Table from "../Table";
import { useHistory } from "react-router";
import { isEmpty } from "lodash-es";
import { Integration } from "@secondcloset/types";
import { useQuery } from "react-query";
import { fetchShops, FetchShopsQuery } from "../../../../../api/integration/shopify";
type Shop = Integration.Shop;

interface StoresTableProps {
  query: FetchShopsQuery;
}

const StoresTable: React.FC<StoresTableProps> = ({ query }) => {
  const history = useHistory();

  const storeIndex = useQuery(["shopifyShops", query], () => fetchShops(query), {
    enabled: !isEmpty(query),
  });

  const getStoresDataSource = (data: Shop[]) => {
    if (isEmpty(data)) return [];
    return data.map((store) => {
      const { name, active, created_at, updated_at, id } = store;

      return {
        key: id,
        name,
        active: active ? "Active" : "Inactive",
        id,
        created_at,
        updated_at,
      };
    });
  };

  const getStoresColumns = () => {
    const renderDate = (date: string) => {
      const d = new Date(date);
      const options = {
        timeZone: "America/New_York",
        hour12: true,
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
      } as Intl.DateTimeFormatOptions;
      const formattedDate = d.toLocaleString("en-US", options);

      return <div>{formattedDate}</div>;
    };

    return [
      { title: "Store", dataIndex: "name", key: "name", width: 300 },
      { title: "Active", dataIndex: "active", key: "active", width: 100 },
      {
        title: "Created At",
        dataIndex: "created_at",
        key: "createdAt",
        render: renderDate,
        width: 230,
      },
      {
        title: "Updated At",
        dataIndex: "updated_at",
        key: "updatedAt",
        render: renderDate,
        width: 230,
      },
    ];
  };

  const headerButtons = query?.organization_id ? (
    <Button
      onClick={() => {
        history.push(`/organizations/${query.organization_id}/stores`);
      }}
      icon={<SyncOutlined />}
    >
      Sync Store
    </Button>
  ) : null;

  const tableProps = {
    columns: getStoresColumns(),
    dataSource: getStoresDataSource(storeIndex.data as unknown as Shop[]),
    loading: storeIndex.isLoading,
  };

  const fullListLink = query?.organization_id ? `/organizations/${query.organization_id}/stores` : null;

  return (
    <div className="fulfillment-table">
      <Table title="Stores" headerButtons={headerButtons} tableProps={tableProps} fullListLink={fullListLink} />
    </div>
  );
};

export default StoresTable;
